const apimUrls = {
    dev: 'https://dev-apimanagement.carlislehomes.com.au/external',
    test: 'https://test-apimanagement.carlislehomes.com.au/external',
    uat: 'https://uat-apimanagement.carlislehomes.com.au/external',
    prod: 'https://prod-apimanagement.carlislehomes.com.au/external',
}

const local = {
    baseUrl: 'http://localhost:7071/api/',
    cacheUrl: 'http://localhost:7071/api/'
}

const dev = {
    baseUrl: apimUrls.dev + '/construction/',
    cacheUrl: apimUrls.dev + '/rollingcache/'
}

const test = {
    baseUrl: apimUrls.test + '/construction/',
    cacheUrl: apimUrls.test + '/rollingcache/'
}

const uat = {
    baseUrl: apimUrls.uat + '/construction/',
    cacheUrl: apimUrls.uat + '/rollingcache/'
}

const prod = {
    baseUrl: apimUrls.prod + '/construction/',
    cacheUrl: apimUrls.prod + '/rollingcache/'
}


const appConstants = (() => {
  if( !(process.env.NODE_ENV === 'production') ) return dev;
  if( process.env.REACT_APP_BUILD_ENV === 'dev' ) return dev;
  if( process.env.REACT_APP_BUILD_ENV === 'test' ) return test;
  if( process.env.REACT_APP_BUILD_ENV === 'uat' ) return uat;
  return prod;

})();

console.log(appConstants);

export default appConstants;